import { z } from 'zod';
import { PaginationOrderDirectionEnum } from '@terra/shared-dto-types';

export const EXTERNAL_ASSET_LIST_SORT_FIELDS = [
  'name',
  'createdAt',
  'updatedAt',
  'signals',
  'findings',
] as const;

export const ExternalAssetListSortFieldSchema = z.enum(
  EXTERNAL_ASSET_LIST_SORT_FIELDS,
);

export const ExternalAssetListOrderBySchema = z.object({
  field: ExternalAssetListSortFieldSchema,
  order: PaginationOrderDirectionEnum,
});

export const EXTERNAL_ASSET_LIST_GROUP_BY_FIELDS = {
  NETBLOCK: ['scope', 'sourceType', 'organization'],
  DOMAIN: ['scope', 'sourceType', 'isTopLevel'],
  HOST: ['sourceType', 'cloudProvider'],
  GATEWAY: ['sourceType', 'providerCategory'],
  NETWORK_SERVICE: ['sourceType', 'transportProtocol'],
  SOFTWARE: ['softwareType', 'vendor'],
  STORAGE_SERVICE: ['scope', 'sourceType', 'provider'],
} as const;

export type ExternalAssetListKind =
  keyof typeof EXTERNAL_ASSET_LIST_GROUP_BY_FIELDS;

export const ExternalAssetListGroupSchema = z.object({
  key: z.string().nullable(),
  count: z.number(),
});

const groupBySchemaFor = <Kind extends ExternalAssetListKind>(kind: Kind) =>
  z.enum(EXTERNAL_ASSET_LIST_GROUP_BY_FIELDS[kind]);

export const externalAssetListOrderingFields = <
  Kind extends ExternalAssetListKind,
>(
  kind: Kind,
) => ({
  orderBy: ExternalAssetListOrderBySchema.array().optional(),
  groupBy: groupBySchemaFor(kind).optional(),
});

export const externalAssetListGroupsField = {
  groups: ExternalAssetListGroupSchema.array().optional(),
};

export type ExternalAssetListSortField = z.infer<
  typeof ExternalAssetListSortFieldSchema
>;
export type ExternalAssetListOrderByDto = z.infer<
  typeof ExternalAssetListOrderBySchema
>;
export type ExternalAssetListGroupDto = z.infer<
  typeof ExternalAssetListGroupSchema
>;
export type ExternalAssetListGroupByField<Kind extends ExternalAssetListKind> =
  (typeof EXTERNAL_ASSET_LIST_GROUP_BY_FIELDS)[Kind][number];
